import { IComuni, ISearchParams } from 'interfaces'
import { Key, useEffect, useState } from 'react'
import { registryService } from 'services'

function useComuni(cityId?: Key, searchParams?: ISearchParams, setError?: (error: any) => void) {
  const [comuni, setComuni] = useState<IComuni[]>([])

  useEffect(() => {
    if (!!cityId) {
      const controller = registryService.getComuni(cityId, setComuni, setError, searchParams)
      return () => controller.abort()
    }
  }, [cityId, searchParams, setError])

  return comuni
}

export default useComuni
